<script>
import { config } from '@/config'
import MainMenu from "./Main.vue"

export default {
  components: {
    MainMenu,
  },
  methods: {
    SignOut() {
      axios.post('./api/odjava/', {withCredentials: true}).then((response) => {
        localStorage.removeItem("User");
        config.User = null;
        config.FullUser = null;
        config.UserLVL =null;
        config.UserID = null;
        config.PwrUser =null;
        this.checkLogin();
      }).catch((error) => {
        localStorage.removeItem("User");
        config.User = null;
        config.FullUser = null;
        config.UserLVL =null;
        config.UserID = null;
        config.PwrUser =null;
        this.$router.push("/Login");
      })
    },
    checkLogin() {
      if (localStorage.getItem('User') !== null) {
        const user = JSON.parse(localStorage.getItem('User'));
        if (user.lvl === 0) {
          config.PwrUser = true;
        }
        this.$router.push('/');
      } else {
        this.$router.push('/Login')
      }
    },
  }
}
</script>
<template>
  <main-menu @odjava="SignOut"/>
</template>